/**
 * 配置模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from './axios';
import qs from 'qs';
//获取策略参数设置
export const getStatistics = (params)=>{
  return axios.post(`${base.base}/statistics/get_statistics`,
    qs.stringify(params)
  )
};
export const getClientList = (params)=>{
  return axios.post(`${base.base}/statistics/get_client_list`,
    qs.stringify(params)
  )
};
export default getStatistics;



// WEBPACK FOOTER //
// ./src/api/statistics.js